export default "__VITE_ASSET__BRYGfDBT__"